import { selector } from 'recoil'
import {
  swipeableDrawerLoginStateAtom,
  swipeableDrawerMenuStateAtom,
  diagnosisTabStateAtom,
} from 'stores/recoil/system/atom'

type TablesStatus = 'DIAGNOSE' | 'NOT_DIAGNOSE'

const selectorSwipeableDrawerLoginStateAtom = selector({
  key: 'selectorSwipeableDrawerLoginStateAtom',
  get: ({ get }) => get(swipeableDrawerLoginStateAtom).state,
  set: ({ set }, newValue: boolean) => {
    set(swipeableDrawerLoginStateAtom, { state: newValue })
  },
})

const selectorSwipeableDrawerSideMeueStateAtom = selector({
  key: 'selectorSwipeableDrawerSideMeueStateAtom',
  get: ({ get }) => get(swipeableDrawerMenuStateAtom).state,
  set: ({ set }, newValue: boolean) => {
    set(swipeableDrawerMenuStateAtom, { state: newValue })
  },
})

const selectorDiagnosisTabStateAtom = selector({
  key: 'selectorDiagnosisTabStateAtom',
  get: ({ get }) => get(diagnosisTabStateAtom).state,
  set: ({ set }, newValue: TablesStatus) => {
    set(diagnosisTabStateAtom, { state: newValue })
  },
})

export {
  selectorSwipeableDrawerLoginStateAtom,
  selectorSwipeableDrawerSideMeueStateAtom,
  selectorDiagnosisTabStateAtom,
}
